import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDashboardApplication,
  getDashboardDelete,
  getDashboardEdit,
  getfilterApplication,
  getLegacyApplicationList,
  createOfflineApplication
} from "../../services/apiEndpoints";

export const getDashboardListing = createAsyncThunk(
  "dashboard/getDashboardListing",
  async (payload: any, thunkAPI) => {
    try {
      const response = await getDashboardApplication(payload);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded",
      );
    }
  },
);

export const getDashboardEditThunk = createAsyncThunk(
  "dashboard/getDashboardEdit",
  async (
    {
      access_id,
      application_categroy_id,
    }: { access_id: number; application_categroy_id: number },
    thunkAPI,
  ) => {
    try {
      const response = await getDashboardEdit(
        access_id,
        application_categroy_id,
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded",
      );
    }
  },
);

export const getDashboardDeleteThunk = createAsyncThunk(
  "dashboard/getDashboardDelete",
  async ({ access_id }: { access_id: number }, thunkAPI) => {
    try {
      const response = await getDashboardDelete(access_id);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded",
      );
    }
  },
);

export const getFilterApplicationThunk = createAsyncThunk(
  "dashboard/getFilterApplication",
  async (_, thunkAPI) => {
    try {
      const response = await getfilterApplication();
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed to load filter data",
      );
    }
  },
);

export const getLegacyApplicationListThunk = createAsyncThunk(
  "dashboard/getLegacyApplicationList",
  async ({ application_code }: { application_code: string }, thunkAPI) => {
    try {
      const response = await getLegacyApplicationList(application_code);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed to load filter data",
      );
    }
  },
);

export const createOfflineApplicationThunk = createAsyncThunk(
  "dashboard/createOfflineApplication",
  async ({ application_code, application_source, application_category }: { application_code: string; application_source: string; application_category: number }, thunkAPI) => {
    try {
      const response = await createOfflineApplication({application_code, application_source, application_category});
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed to load filter data",
      );
    }
  },
);
